module.exports = ".kan-file-log-dialog-container {\n  font-size: 13px; }\n  .kan-file-log-dialog-container .kan-file-log-file-name {\n    font-size: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/file-log-dialog/component.scss
// module id = ./src/modules/admin/dialogs/file-log-dialog/component.scss
// module chunks = main